module.exports = __webpack_public_path__ + "media/images/emoticons/info01-f8eec7c513bc795de46131412c273421.gif";